import ArrowBack from '@mui/icons-material/ArrowBack';
import { Button, Chip, CircularProgress } from '@mui/material';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { useLocation, useNavigate } from 'react-router-dom';

import Move9jaCard from '../shared/Move9jaCard';
import { useState } from 'react';
import DashboardLayout from '../layouts/DashboardLayout';
import { Close } from '@mui/icons-material';
import { useQuery } from '@tanstack/react-query';
import { getAddons } from '../services/addons';
import { format } from 'date-fns';
import { getDateSuffix } from '../shared/TheCalender';

const BookingDetails = () => {
  const navigate = useNavigate();
  const [selectedAddons, setSelectedAddons] = useState<number[]>([]);
  const location = useLocation();
  const { searchResults, selectedResult, selectedSeat } = location.state || {};

  const { data, isLoading } = useQuery({
    queryKey: ['ADD_ONS'],
    queryFn: getAddons,
  });

  console.log('Add ons', data?.data?.addons);

  const onClickAddons = (index: number) => {
    setSelectedAddons((prevSelectedAddons) =>
      prevSelectedAddons.includes(index)
        ? prevSelectedAddons.filter((i) => i !== index)
        : [...prevSelectedAddons, index]
    );
  };

  const calculateTotalPrice = () => {
    return selectedAddons.reduce((total, addonId) => {
      const addon = data?.data?.addons.find(
        (card: any) => card._id === addonId
      );
      return total + (addon ? addon.price : 0);
    }, 0);
  };

  const handleContinue = () => {
    const selectedAddonsIds = selectedAddons.map((addonId) => addonId);
    const totalPrice = calculateTotalPrice();

    const busFee = selectedResult?.price;
    const busId = selectedResult?.vehicleId;
    const today = new Date();
    const bookingData = {
      bus_id: busId,
      selected_seat: selectedSeat,
      travel_date: format(today, 'yyyy-MM-dd'),
      addons_id: selectedAddonsIds,
      type: 'single_trip', // or "round_trip"
    };

    navigate('/summary', {
      state: {
        bookingData,
        totalPrice,
        busFee,
        searchResults,
        selectedResult,
        selectedSeat,
      },
    }); // Passnig bookingData to the summary page and other useful data
  };

  const formattedDate = (date: Date) => {
    const day = format(date, 'd');
    const month = format(date, 'MMM');
    return `${day}${getDateSuffix(Number(day))} ${month}`;
  };

  return (
    <DashboardLayout>
      <Box height='auto' mx={{ md: '14%' }}>
        <Box
          height='168px'
          bgcolor='#000'
          color='#FFF'
          display={{ md: 'flex', xs: 'none' }}
          alignItems='center'
          justifyContent='space-between'
          px={2}
          pt={8}
        >
          <Box>
            <Typography
              fontSize='20px'
              fontWeight={700}
              sx={{ textTransform: 'capitalize' }}
            >
              {selectedResult.from} - {selectedResult.to}
            </Typography>
            <Typography fontSize='14px' fontWeight={400}>
              {searchResults.length} parks result (s)
            </Typography>
            <Typography fontSize='14px' fontWeight={400}>
              {formattedDate(new Date())}
            </Typography>
          </Box>
          <Box display='flex' alignItems='end' flexDirection='column'>
            <Close
              sx={{ cursor: 'pointer' }}
              onClick={() => navigate('/home')}
            />
            <Typography height='25px' />
            <Typography
              fontSize='14px'
              fontWeight={400}
              sx={{ textDecoration: 'underline' }}
            >
              Modify search
            </Typography>
          </Box>
        </Box>
        <Box p={2}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 1,
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <IconButton
                onClick={() => {
                  navigate(-1);
                }}
              >
                <ArrowBack />
              </IconButton>
              <Typography fontWeight={700} fontSize={20}>
                Booking details
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box p={2}>
          <Move9jaCard marginTop={0} title='Add Ons'>
            {isLoading && (
              <Box
                display='flex'
                alignItems='center'
                justifyContent='center'
                p={3}
              >
                <CircularProgress />
              </Box>
            )}
            <Box
              p={1}
              display='grid'
              gridTemplateColumns={{ md: '1fr 1fr', xs: '1fr' }}
              gap='8px'
            >
              {data?.data?.addons.map((card: any) => (
                <Box
                  key={card._id}
                  display='flex'
                  alignItems='start'
                  justifyContent='space-between'
                  borderRadius='8px'
                  border='1px solid #E4E7EC'
                  p={1}
                  mb={1}
                >
                  <Box>
                    <Typography fontSize='12px' fontWeight={600} mb={1}>
                      {card.name}
                    </Typography>
                    <Typography fontSize='12px' fontWeight={400} mb={1}>
                      {card.description}
                    </Typography>
                    <Typography
                      fontSize='12px'
                      fontWeight={600}
                      color='#3E7EFF'
                    >
                      + NGN {card?.price.toLocaleString()}
                    </Typography>
                  </Box>
                  <Chip
                    label={
                      selectedAddons.includes(card._id) ? '- Remove' : '+ Add'
                    }
                    onClick={() => onClickAddons(card._id)}
                    sx={{
                      bgcolor: selectedAddons.includes(card._id)
                        ? '#FFF7E8'
                        : '#F6F6F6',
                      color: selectedAddons.includes(card._id)
                        ? '#DA4733'
                        : '#5D5C63',
                    }}
                  />
                </Box>
              ))}
            </Box>
          </Move9jaCard>
          <Button
            sx={{
              borderRadius: '8px',
              p: '12px 24px',
              mt: 2,
              width: { xs: '100%', md: '300px' },
            }}
            variant='contained'
            onClick={handleContinue}
          >
            Continue
          </Button>
        </Box>
      </Box>
    </DashboardLayout>
  );
};

export default BookingDetails;
